const SET_USER = 'user/SET_USER'
const PUSH_FLOW = 'PUSH_FLOW'

export const state = () => ({
  isCanceled: false,
  flow: [],
  certificateExpirationDate: ''
})

export const actions = {
  async cancelSubscription({ commit }, payload) {
    const body = {
      toggle: true
    }

    try {
      const user = await this.$axios.$put('/api/user/subscription', body)

      commit(SET_USER, user, { root: true })
    } catch (err) {
      console.error(err)
    }
  },

  pushFlow({ commit }, payload) {
    commit(PUSH_FLOW, payload)
  },

  async sendCustomerFlow({ state, commit, rootGetters }) {
    const body = {
      isCanceled: rootGetters['user/isCanceled'],
      flow: state.flow
    }

    try {
      await this.$axios.post('/api/cancel/flow', body)
      commit('resetFlow')
    } catch (err) {
      console.error(err)
    }
  },

  async sendSurvey({ commit }, payload) {
    try {
      const response = await this.$axios.$post('/api/surveys/cancellation', {
        flow: Object.values(payload).reduce((acc, cur) => acc.concat(cur), [])
      })

      if (response.expirationDate) {
        commit('setCertificateExpirationDate', response.expirationDate)
      }

      return response
    } catch (err) {
      console.error(err)
    }
  }
}

export const mutations = {
  [PUSH_FLOW](state, payload) {
    state.flow.push({
      step: state.flow.length + 1,
      page_url: window.location.pathname.replace('/my_account', ''),
      answer: payload
    })
  },

  resetFlow(state) {
    state.flow = []
  },

  setCertificateExpirationDate(state, payload) {
    state.certificateExpirationDate = payload
  }
}

export const getters = {
  certificateExpirationDate(state) {
    return state.certificateExpirationDate
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
